import { render, staticRenderFns } from "./ZonesAdmin.vue?vue&type=template&id=15e37c86&lang=html"
import script from "./ZonesAdmin.vue?vue&type=script&lang=js"
export * from "./ZonesAdmin.vue?vue&type=script&lang=js"
import style0 from "./ZonesAdmin.vue?vue&type=style&index=0&id=15e37c86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports